import React, { useEffect, useMemo, useState } from "react";
import { useTable, useSortBy, usePagination, useRowSelect } from "react-table";
import "tailwindcss/tailwind.css";
import { Empty } from "antd";
import "../../styles.css";
import Vectorsorting from "../../assets/Vectorsorting.svg";
import ShimmerLoader from "../../loading";
import { useTranslation } from "react-i18next";
import { Navigate, useNavigate } from "react-router-dom";
import CustomPagination from "../../components/CustomWidgets/CustomPagination";

const ItemWiseSaleTable = ({ additionalData, pagination }) => {
    const { t, i18n } = useTranslation();
    const [flag, setflag] = useState(false);
    const navigate = useNavigate();

    const openOrderList = (id) => {
        navigate(`/vendorDetails?id=${id}`);
    };

    const data = useMemo(
        () =>
            //   additionalData?.status
            //     ? additionalData?.all_product
            additionalData || [],
        [additionalData]
    );

    useEffect(() => {
        if (additionalData?.length === 0 && !flag) {
            const timer = setTimeout(() => {
                setflag(true);
            }, 1000);

            return () => clearTimeout(timer);
        }

    }, [additionalData, flag]);
    console.log("data==>", data);

    const columns = useMemo(
        () => [
            {
                Header: (
                    <div className="text-start justify-start" title={t("Date & Time")}>
                        {t("Date & Time")}
                    </div>
                ),
                width: "8%", // Add this line
                accessor: "create_date",
                headerClassName: "text-start",
                Cell: ({ row }) => (
                    <div className="text-start justify-start">{row.original.create_date}</div>
                ),
            },

            // {
            //     Header: (
            //         <div className="text-start justify-start" title={t("Store")}>
            //             {t("Store")}
            //         </div>
            //     ),
            //     width: "10%", // Add this line
            //     accessor: "company_name",
            //     headerClassName: "text-start",
            //     Cell: ({ row }) => (
            //         <div className="text-start justify-start">{row.original.company_name}</div>
            //     ),
            // },
            {
                Header: (
                    <div className="text-start justify-start" title={t("Barcode")}>
                        {t("Barcode")}
                    </div>
                ),
                width: "10%", // Add this line
                accessor: "barcode",
                headerClassName: "text-start",
                Cell: ({ row }) => (
                    <div className="text-start justify-start">{row.original.barcode || "--"}</div>
                ),
            },
            {
                Header: (
                    <div className="text-start justify-start" title={t("Product Name")}>
                        {t("Product Name")}
                    </div>
                ),
                width: "10%", // Add this line
                accessor: "product_name",
                headerClassName: "text-start",
                Cell: ({ row }) => (
                    <div className="text-start justify-start">{row.original.product_name || "--"}</div>
                ),
            },
            {
                Header: (
                    <div className="text-start" title={t("Total Value")}>
                        {t("Total Value")}
                    </div>
                ),
                width: "6%",// Add this line
                accessor: "price_subtotal",
                Cell: ({ row }) => (
                    <div className="text-start">{`EGP ${row.original.price_subtotal || 0}`}</div>
                ),
            },
            {
                Header: (
                    <div className="text-start" title={t("Total Cost")}>
                        {t("Total Cost")}
                    </div>
                ),
                width: "6%",// Add this line
                accessor: "total_cost",
                Cell: ({ row }) => (
                    <div className="text-start">{`EGP ${row.original.total_cost || 0}`}</div>
                ),
            },
            {
                Header: (
                    <div className="text-start justify-start" title={t("Quantity Sold")}>
                        {t("Quantity Sold")}
                    </div>
                ),
                width: "5%", // Add this line
                accessor: "qty",
                headerClassName: "text-start",
                Cell: ({ row }) => (
                    <div className="text-start justify-start">{row.original.qty || "--"}</div>
                ),
            },
            {
                Header: (
                    <div className="text-start justify-start" title={t("Cashier")}>
                        {t("Cashier")}
                    </div>
                ),
                width: "10%", // Add this line
                accessor: "cashier",
                headerClassName: "text-start",
                Cell: ({ row }) => (
                    <div className="text-start justify-start">{row.original.cashier || "--"}</div>
                ),
            },
            {
                Header: (
                    <div className="text-start justify-start" title={t("Payment Method")}>
                        {t("Payment Method")}
                    </div>
                ),
                width: "10%", // Add this line
                accessor: "payment_type",
                headerClassName: "text-start",
                Cell: ({ row }) => (
                    <div className="text-start justify-start">{t(row.original.payment_type || "--")}</div>
                ),
            },
        ],
        [t]
    );


    const {
        headerGroups,
        prepareRow,
        page,
        nextPage,
        setPageSize,
        state: { pageSize },
    } = useTable(
        {
            columns,
            data: data,
            initialState: { pageSize: 20 },
        },
        useSortBy,
        usePagination,
        useRowSelect
    );

    const [pageIndex, setpageIndex] = useState(1);

    useEffect(() => {
        const pageDetails = {
            limit: pageSize,
            offset: pageSize * (pageIndex - 1) < 0 ? 0 : pageSize * (pageIndex - 1),
        };

        if (pageSize) pagination(pageDetails);
    }, [pageSize, pageIndex]);

    return (
        <>
            <div
                className="container flex flex-col mx-auto mt-4"
                style={{ maxWidth: "100%" }}
            >
                {additionalData?.length == 0 && flag == false ? (
                    <div className="h-screen w-[90%] mt-2 ">
                        <ShimmerLoader />
                    </div>
                ) : (
                    <>
                        {/* Header Table (Fixed) */}
                        <div>
                            <table
                                className="font-normal  max-w-[100%] sm:w-[97.6%] md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                                style={{ tableLayout: "fixed" }}
                            >
                                <thead>
                                    {headerGroups.map((headerGroup, headerIndex) => {
                                        const { key: headerKey, ...headerGroupProps } =
                                            headerGroup.getHeaderGroupProps();
                                        return (
                                            <tr
                                                key={headerKey}
                                                {...headerGroupProps}
                                                className="bg-[#78CFEC66] text-sm font-semibold overflow-hidden whitespace-nowrap"
                                            >
                                                {headerGroup.headers.map((column, colIndex) => {
                                                    const { key: columnKey, ...columnProps } =
                                                        column.getHeaderProps(
                                                            column.getSortByToggleProps()
                                                        );
                                                    return (
                                                        <th
                                                            key={columnKey}
                                                            {...columnProps}
                                                            className="py-3 whitespace-nowrap"
                                                            style={{ width: column.width }} // Set column width
                                                        >
                                                            <div className="flex items-start ms-2 text-sm ">
                                                                {column.render("Header")}
                                                                <span className="">
                                                                    {column.isSorted ? (
                                                                        column.isSortedDesc ? (
                                                                            <img
                                                                                src={Vectorsorting}
                                                                                style={{ minHeight: 10, minWidth: 10 }}
                                                                                alt="vector"
                                                                            />
                                                                        ) : (
                                                                            <img
                                                                                className="rotate-180"
                                                                                src={Vectorsorting}
                                                                                alt="vector"
                                                                            />
                                                                        )
                                                                    ) : (
                                                                        ""
                                                                    )}
                                                                </span>
                                                            </div>
                                                        </th>
                                                    );
                                                })}
                                            </tr>
                                        );
                                    })}
                                </thead>
                            </table>
                        </div>

                        {/* Body Table (Scrollable) */}
                        <div
                            className="scrollbar-none bg-white"
                            style={{
                                overflowY: "auto",
                                maxHeight: "450px", // Adjust height as needed
                            }}
                        >
                            <table
                                className="font-normal max-w-[100%] sm:w-[97.6%]  md:w-[97.6%] lg:w-[97.6%] xl:w-[97.6%] overflow-hidden rounded-lg"
                                style={{ tableLayout: "fixed" }}
                            >
                                <tbody className="bg-[#F7F9FD] text-center overflow-hidden">
                                    {page.map((row) => {
                                        prepareRow(row);
                                        return (
                                            <React.Fragment key={row.id}>
                                                <tr
                                                    {...row.getRowProps()}
                                                    className="relative hover:bg-white cursor-pointer transition duration-300 border-b border-gray-300 fixed-row-height"
                                                //   onClick={() => openOrderList(row.original.id)}
                                                >
                                                    {row.cells.map((cell, index) => (
                                                        <td
                                                            key={index}
                                                            {...cell.getCellProps()}
                                                            className={`p-2 text-[#272728] h-1212 text-sm font-normal ${index < row.cells.length - 1 ? "relative" : ""
                                                                } ${cell?.column?.Header == "Product"
                                                                    ? "cursor-pointer"
                                                                    : ""
                                                                }`}
                                                            style={{ width: cell.column.width }} // Match column width
                                                        >
                                                            {cell.render("Cell")}
                                                        </td>
                                                    ))}
                                                </tr>
                                            </React.Fragment>
                                        );
                                    })}
                                    {page.length === 0 && (
                                        <tr>
                                            <td colSpan={"100%"}>
                                                <Empty
                                                    className="mt-10"
                                                    description={t("No data available")}
                                                />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                        {/* Pagination */}
                        <div className="">
                            <CustomPagination
                                data={data?.length}
                                pageIndex={pageIndex}
                                pageCount={page?.length}
                                canPreviousPage={pageIndex != 1 ? true : false}
                                canNextPage={data?.length == pageSize ? true : false}
                                gotoPage={(page) => {
                                    nextPage(page);
                                }}
                                previousPage={() => {
                                    setpageIndex(pageIndex - 1);
                                }}
                                nextPage={() => {
                                    setpageIndex(pageIndex + 1);
                                }}
                                pageSize={pageSize}
                                setPageSize={(pageSize) => {
                                    setPageSize(pageSize);
                                }}
                            />
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default ItemWiseSaleTable;
